/**
 * Class description
 *
 * Created: 2019-08-02
 * @author jonas
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {WinterHoardGameModuleConfig} from "../../WinterHoardGameModuleConfig";
import {GameModeTransitionControllerWithView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionControllerWithView";
import {GameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionView";

export class WinterHoardTransitionController extends GameModeTransitionControllerWithView {

    constructor(fromMode:string, toMode:string, view:GameModeTransitionView) {
        super(fromMode, toMode, view);
    }

    /**
     * Set up mode views and layout while screen is covered by intro/outro screen.
     */
    protected prepareToEnterMode():void {
        //debugger;
        if(this._toMode === "FREESPIN_COMBINED") {
            WinterHoardGameModuleConfig.freeSpinMultiplierView.show();
        }

        if(this._toMode == GameMode.NORMAL) {
            WinterHoardGameModuleConfig.freeSpinCounterView.hide();
            WinterHoardGameModuleConfig.freeSpinMultiplierView.hide();
            WinterHoardGameModuleConfig.symbolData.reset();
            WinterHoardGameModuleConfig.symbolDataStopped.reset();
        }

        super.prepareToEnterMode();
    }

}